export default function routeMaker(inputString) {
    let result = inputString.toLowerCase();
    // eslint-disable-next-line
    result = result.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,"");
    return result.replace(/\s/g, "-");
}